import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import clsx from 'clsx';
import { InfoIcon } from 'reaxl';
import { formatNumber } from '@atc/string-fns';
import _get from 'lodash/get';
import { useDevice } from '@atc/react-device';

/**
 * FilterCheckboxLabel will render a formatted presentation of a checkbox label.
 *
 */

function FilterCheckboxLabel(_ref) {
  let {
    label,
    count,
    disabled,
    moreInfo,
    filterBadge,
    onCloseClick,
    showCount = true
  } = _ref;
  const device = useDevice();
  const isXs = _get(device, 'is.xs', false);
  const countDisplay = useMemo(() => {
    if (count) {
      return `(${formatNumber({
        value: count
      })})`;
    }
    if (disabled) {
      return '(0)';
    }
    return '';
  }, [count, disabled]);
  const moreInfoOverlayTriggerHandler = e => {
    if (!isXs) {
      e.stopPropagation();
    }
    e.preventDefault();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("span", {}, "label", label), /*#__PURE__*/_jsx("span", {
    className: "text-nowrap"
  }, "additional-info", showCount && count !== undefined && /*#__PURE__*/_jsx("span", {
    className: clsx({
      'text-gray': !disabled
    })
  }, "count", ' ', countDisplay), moreInfo && /*#__PURE__*/_jsx("span", {}, "more-info", ' ', /*#__PURE__*/_jsx(InfoIcon, {
    popoverId: "filter-more-info-popover",
    onClick: moreInfoOverlayTriggerHandler,
    placement: "bottom",
    infoText: moreInfo,
    onCloseClick: onCloseClick
  })), filterBadge && /*#__PURE__*/_jsx("span", {
    className: "margin-left-2 text-success text-bold"
  }, void 0, filterBadge)));
}
export default FilterCheckboxLabel;